import { useForm, FormProvider } from "react-hook-form";
import SelectDropdown from "../features/header/SelectDropdowns";
import { agentIds } from "./Constants";

interface AgentFilterFormProps {
  selectedAgent: { label: string; value: string };
  setSelectedAgent: (option: { label: string; value: string }) => void;
}

export default function AgentFilterForm({
  selectedAgent,
  setSelectedAgent,
}: AgentFilterFormProps) {
  const methods = useForm();
  const agentOptions = Object.entries(agentIds).map(([label, value]) => ({
    label,
    value,
  }));

  return (
    <FormProvider {...methods}>
      <form className="w-full">
        <SelectDropdown
          label="Filter Agent"
          name="filterAgent"
          options={Object.entries(agentIds).map(([label, value]) => ({
            label,
            value,
          }))}
          defaultValue={selectedAgent.label}
          onChange={(value) => {
            const found = agentOptions.find((option) => option.value === value);
            if (found) {
              setSelectedAgent({
                label: found.label,
                value: found.value,
              });
            }
          }}
          placeHolder="Choose an agent..."
          isAgent={true}
        />
      </form>
    </FormProvider>
  );
}
